import { render } from "./Fieldset.vue?vue&type=template&id=18276668&scoped=true&ts=true"
import script from "./Fieldset.vue?vue&type=script&lang=ts"
export * from "./Fieldset.vue?vue&type=script&lang=ts"

import "./Fieldset.vue?vue&type=style&index=0&id=18276668&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18276668"]])

export default __exports__